import { useQuery } from '@tanstack/react-query';
import type { DayScheduleResponse, WeekScheduleResponse } from '../types';
import { api } from './client';
import { qk } from './keys';

export function useDaySchedule(channel: string | null, locale: string, date: string) {
  return useQuery({
    queryKey: qk.scheduleDay(channel ?? '', locale, date),
    enabled: !!channel,
    // Use the admin endpoint so responses are never served from a CDN/proxy
    // cache. The public /schedule carries max-age=60 which causes the Now
    // Playing page to show stale slot data after an edit.
    queryFn: () =>
      api.get<DayScheduleResponse>('/admin/schedule', {
        channel: channel ?? '',
        locale,
        date,
      }),
  });
}

export function useWeekSchedule(channel: string | null, locale: string, weekStart: string) {
  return useQuery({
    queryKey: qk.scheduleWeek(channel ?? '', locale, weekStart),
    enabled: !!channel,
    // Use the admin endpoint so responses are never served from a CDN/proxy
    // cache. The public /schedule/this-week carries max-age=300 which causes
    // a page refresh to show stale slot positions after a drag/edit.
    queryFn: () =>
      api.get<WeekScheduleResponse>('/admin/schedule/this-week', {
        channel: channel ?? '',
        locale,
        weekStart,
      }),
  });
}
